import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const AddFileResourcePopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "AddFileResourcePopup" */ './View'),
  'popup'
);
